// extracted by mini-css-extract-plugin
module.exports = {"trial_wrapper":"upgrade-to-download_trial_wrapper__IJiFW","upgrade_text":"upgrade-to-download_upgrade_text__YX1Un"};